import { Search, ShoppingCartOutlined } from "@mui/icons-material";
import { Badge, Menu, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";
import { styled } from "styled-components";
import { NavLink, useNavigate } from "react-router-dom";

const Navbar = ({ activeMenuItem, isOtherScreen = false }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [isExtended, setIsExtended] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("");
  const textColor =
    activeMenuItem === "videoSlider" ||
    activeMenuItem === "categories" ||
    activeMenuItem === "appointment" ||
    activeMenuItem === "ProductDetailCover" ||
    activeMenuItem === "imageSlider"
      ? "#f5fbfd"
      : "black";

  const handleScrollToScreenComponents = (MenuItem) => {
    setSelectedMenuItem(MenuItem);
    const portfoliosSection = document.getElementById(MenuItem);
    if (isOtherScreen) {
      navigate(`/#${MenuItem}`);
    } else {
      if (portfoliosSection) {
        portfoliosSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <Container>
      <Wrapper>
        <Left>
          <Language textColor={textColor}>EN</Language>
          <SearchContainer textColor={textColor}>
            <Input />
            <Search
              style={{ color: textColor, fontSize: isMobile ? 12 : 24 }}
            />
          </SearchContainer>
        </Left>
        <Logo
          textColor={textColor}
          onClick={() => {
            handleScrollToScreenComponents("videoSlider");
            setIsExtended(false);
          }}
        >
          LuxeDesign.
        </Logo>
        {!isMobile ? (
          <Right>
            <MenuItem
              isSelected={selectedMenuItem === "aboutUs"}
              textColor={textColor}
              onClick={() => {
                handleScrollToScreenComponents("aboutUs");
                setIsExtended(false);
              }}
            >
              ABOUT US
            </MenuItem>
            <MenuItem
              isSelected={selectedMenuItem === "videoSlider"}
              textColor={textColor}
              onClick={() => {
                handleScrollToScreenComponents("videoSlider");
                setIsExtended(false);
              }}
            >
              SERVICES
            </MenuItem>
            <MenuItem
              isSelected={selectedMenuItem === "portfolios"}
              textColor={textColor}
              onClick={() => {
                handleScrollToScreenComponents("portfolios");
                setIsExtended(false);
              }}
            >
              LUXE PROJECTS
            </MenuItem>
            {/* <MenuItem textColor={textColor}>
              <Badge badgeContent={0} color="primary">
                <ShoppingCartOutlined />
              </Badge>
            </MenuItem> */}
          </Right>
        ) : (
          <Right>
            <MenuIcon
              style={{ color: textColor, fontSize: 24 }}
              onClick={() => {
                setIsExtended(!isExtended);
              }}
            />
            {isExtended && (
              <ExtendContainer>
                <MenuItem
                  isSelected={selectedMenuItem === "aboutUs"}
                  textColor={textColor}
                  onClick={() => {
                    handleScrollToScreenComponents("aboutUs");
                    setIsExtended(false);
                  }}
                >
                  ABOUT US
                </MenuItem>
                <MenuItem
                  isSelected={selectedMenuItem === "videoSlider"}
                  textColor={textColor}
                  onClick={() => {
                    handleScrollToScreenComponents("videoSlider");
                    setIsExtended(false);
                  }}
                >
                  SERVICES
                </MenuItem>
                <MenuItem
                  isSelected={selectedMenuItem === "portfolios"}
                  textColor={textColor}
                  onClick={() => {
                    handleScrollToScreenComponents("portfolios");
                    setIsExtended(false);
                  }}
                >
                  LUXE PROJECTS
                </MenuItem>
              </ExtendContainer>
            )}
          </Right>
        )}
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  /* width: 100%; */
  /* height: 65px; */
  /* height: 8vh; */
  /* height: 15%; */
`;

const Wrapper = styled.nav`
  flex: 1;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    padding: 10px 10px;
  }
`;

// Left side of the container
const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    padding-right: 40px;
  }
`;

const Language = styled.span`
  color: ${(props) => props.textColor};
  font-size: 14px;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const SearchContainer = styled.div`
  border: 0.5px solid lightgrey;
  display: flex;
  align-items: center;
  margin-left: 25px;
  padding: 5px;
  border-color: ${(props) => props.textColor};
  @media (max-width: 768px) {
    margin-left: 10px;
    padding: 3px 5px 3px 3px;
  }
`;

const Input = styled.input`
  border: none;
  @media (max-width: 768px) {
    width: 45px;
    height: 10px;
    margin-right: 2px;
  }
`;

const Logo = styled.h1`
  color: ${(props) => props.textColor};
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
  @media (max-width: 768px) {
    flex: 1;
    font-size: 22px;
  }
`;

// Right side of the container
const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MenuItem = styled.h1`
  text-decoration: none;
  font-size: ${(props) => (props.isSelected ? "16px" : "14px")};
  font-weight: ${(props) => (props.isSelected ? "bold" : "600")};
  color: ${(props) => props.textColor};
  cursor: pointer;
  &:hover {
    opacity: 0.2;
    transform: scale(1.1);
  }
  margin-left: 25px;
  @media (max-width: 768px) {
    color: black;
    font-size: 12px;
    margin-left: 0px;
  }
`;

const ExtendContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 40px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 10px 10px 10px 15px;
  border-radius: 15px;
  background-color: #f5fbfd;
`;

export default Navbar;
